<app-progress-spinner [show]="isLoading"></app-progress-spinner>
@if (!isLoading) {
  <div class="analyst-enablement">
    <div class="enablement-card">
      <div class="enablement-main">
        <div class="enablement-copy">
          <div class="enablement-title-row">
            <span class="enablement-title">{{ 'Enable AI Analyst' | translate }}</span>
            <span class="status-pill" [class.on]="isEnabled">
              {{ (isEnabled ? 'Enabled' : 'Disabled') | translate }}
            </span>
          </div>
          <p class="enablement-warning">
            {{ 'Disabling the AI Analyst immediately blocks every user in your tenant from asking new questions.' | translate }}
          </p>
        </div>
        <mat-slide-toggle
          color="primary"
          class="enablement-toggle"
          [(ngModel)]="isEnabled"
          [disabled]="isSaving"
          [aria-label]="'Enable AI Analyst' | translate">
        </mat-slide-toggle>
      </div>
      <div class="enablement-footer">
        <button type="button" class="btn save-modal-btn" [disabled]="isSaving" (click)="save()">
          {{ 'Save' | translate }}
        </button>
      </div>
    </div>
  </div>
}
